import { Component, ViewContainerRef } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { WithDrawalsViewModel } from '../../models/Withdrawals/withdrawals-view';
import { Customer } from '../../models/customer/customer-model';
import { WithdrawlsService } from '../../services/withdrawls/withdrawls.service';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { CustomerService } from '../../services/customer/customer.service';

@Component({
    selector: 'app-withdrawal-request',
    templateUrl: './withdrawal-request.component.html',
    styleUrls: ['./withdrawal-request.component.scss']
})
/** withdrawal-request component*/
export class WithdrawalRequestComponent {
    public withdrawals: WithDrawalsViewModel[];
    public customers: Customer[];
    //Filter items from grid
    filteredItems: any[];
    public rowsOnPage: number;
    public arrRowsPerPage: number[];
    public isDeleteAllowed: boolean = false;
    public isEditAllowed: boolean = false;
    public isCreateAllowed: boolean = false;
    /** withdrawal-request ctor */
    constructor(private readonly WithdrawlService: WithdrawlsService, private readonly CustomerService: CustomerService, private readonly utilitiesService: UtilitiesService,
        public toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
        this.rolePermissionService.GetRolePermissions("WithdrawalRequest").subscribe(
            data => {
                if (data != null) {

                    var create = data.filter(function (element) {
                        return (element.action == "create");
                    });

                    var deletePermission = data.filter(function (element) {
                        return (element.action == "delete");
                    });

                    var edit = data.filter(function (element) {
                        return (element.action == "edit");
                    });

                    if (create.length > 0)
                        this.isCreateAllowed = true;

                    if (edit.length > 0)
                        this.isEditAllowed = true;

                    if (deletePermission.length > 0)
                        this.isDeleteAllowed = true;
                        
                    this.isEditAllowed = true;
                    this.customers = [];
                    this.getWithdrawals();
                    this.GetRowsPerPageList();
                    this.getCustomers();
                    this.toastr.setRootViewContainerRef(vcr);
                }
                else {
                    this.router.navigate(["/"]);
                }
            }
        )
    }

    getWithdrawals() {
        this.WithdrawlService.GetWithDrawalRequest().subscribe(
            data => {
                this.withdrawals = data;
                this.filteredItems = data;
            }
        )
    }
    getCustomers() {
        this.CustomerService.getCustomer().subscribe(
            data => {
                this.customers = data;
            }
        )
    }
    isCustomerNull(id: number) {
        return (this.customers.filter(i => i.customerID == id).length == 0);
    }
    // Populate the row per page list
    GetRowsPerPageList() {
        this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
        this.rowsOnPage = this.arrRowsPerPage[0];
    }
    // Search the Grid
    onSearch(searchText: string) {
        if (searchText != "") {
            this.filteredItems = this.utilitiesService.GetSearchedResult(this.withdrawals, searchText);

        } else {
            this.filteredItems = this.withdrawals;
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/finance-management/withdrawal-request/withdrawal-request.component.ts